import { render, staticRenderFns } from "./CourseBadgeAssignDialog.vue?vue&type=template&id=1fea1155&scoped=true&"
import script from "./CourseBadgeAssignDialog.vue?vue&type=script&lang=js&"
export * from "./CourseBadgeAssignDialog.vue?vue&type=script&lang=js&"
import style0 from "./CourseBadgeAssignDialog.vue?vue&type=style&index=0&id=1fea1155&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fea1155",
  null
  
)

export default component.exports